import { useState } from "react";
import { Box, Divider, Grid2, Popover, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';

import CloseButton from "../../../Components/CloseButton";

const styles = {
    popoverPaper: {
        width: 'fit-content',
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        boxShadow: '-2px -2px 4px 0px rgba(151, 151, 151, 0.25), 2px 2px 4px 0px rgba(151, 151, 151, 0.25)',
    },
};


const AlertConditionsDropdown = ({ alertInfo }) => {
    const { t } = useTranslation(['common', 'digital_twin'])
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'single-alert-condition-popover' : undefined;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box>
            <Box>
                <Typography
                    sx={{
                        cursor: 'pointer',
                        lineHeight: '20px',
                        '&:hover': { color: '#4D44D8' }
                    }} onClick={handleClick} variant="fw500s12lh246D72F6">View Conditions</Typography>
            </Box>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                slotProps={{ paper: { sx: styles.popoverPaper } }}
            >
                <Box sx={{ minWidth: '350px', py: 3, px: 4 }}>
                    <Grid2 container justifyContent={'space-between'} alignItems={'center'}>
                        <Typography variant="fw600s14c000000" sx={{ lineHeight: '24px' }}>Alert Conditions</Typography>
                        <CloseButton onClick={handleClose} size={'small'} />
                    </Grid2>

                    <Box sx={{ mt: 3.5, mb: 4 }}>
                        <Typography variant="fw400s16c000000">{t(alertInfo.alertDescription)}</Typography>
                    </Box>

                    <Grid2 container gap={4}>
                        <Grid2>
                            {
                                alertInfo.alertSeverityMeta && alertInfo.alertSeverityMeta.filter((meta) => meta.severityName.toLowerCase() != 'resolved').map((severityMeta) => (
                                    <Grid2 container flexDirection={'column'} sx={{ mb: 3 }} key={severityMeta.severityName}>
                                        <Typography variant="fw500s12c686868">{severityMeta.severityName} Severity: </Typography>
                                        <Typography variant="fw400s12c686868">{severityMeta.alertDisplayCondition || 'NA'} </Typography>
                                    </Grid2>
                                ))
                            }
                        </Grid2>

                        <Divider sx={{ borderWidth: '1px', }} />

                        <Grid2>
                            {
                                alertInfo.alertSeverityMeta && alertInfo.alertSeverityMeta.filter((meta) => meta.severityName.toLowerCase() == 'resolved').map((severityMeta) => (
                                    <Grid2 container flexDirection={'column'} sx={{ mb: 3 }} key={severityMeta.severityName}>
                                        <Typography variant="fw500s12c686868">{severityMeta.severityName} </Typography>
                                        <Typography variant="fw400s12c686868">{severityMeta.alertDisplayCondition || 'NA'} </Typography>
                                    </Grid2>
                                ))
                            }
                        </Grid2>
                    </Grid2>
                </Box>

            </Popover >
        </Box >

    )
}

export default AlertConditionsDropdown
